import { Outlet } from "react-router";

import { useAppContainerProps } from "./AppContainer";
import { useVisitorTracker } from "./Main/VisitorTracker";
import RoutesContextProvider from "./Routes/RoutesContext";
import RouterLocationManager from "./Routing/RouterLocationManager";
import AppInner from "./AppInner";
import Main from "./Main/Main";
import { useUrlRedirectionsManager } from "./Routing/UrlRedirectionsManager";
import { useMatomoTracking } from "./Utils/useMatomoTracking";
import { useFocusVisibilityManager } from "./Utils/FocusVisibilityManager";
import NavigationIndicator from "./Utils/NavigationIndicator";

const AppLayout = () => {
  const { analytics } = useAppContainerProps();

  useVisitorTracker();
  useUrlRedirectionsManager();
  // Whenever the user accepts cookies, connect the PiwikReactRouter to the redux history
  // to allow automatic tracking of page views.
  useMatomoTracking(analytics);

  useFocusVisibilityManager();

  return (
    <RoutesContextProvider>
      <RouterLocationManager>
        <AppInner>
          <NavigationIndicator />

          <Main>
            <Outlet />
          </Main>
        </AppInner>
      </RouterLocationManager>
    </RoutesContextProvider>
  );
};

export default AppLayout;
